import Chart from 'chart.js';
import classNames from 'classnames';
import find from 'lodash/find';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import sum from 'lodash/sum';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchStatsPlatforms} from '../../../../../actions/entities/statistics/platforms';
import earthFlag from '../../../../../assets/img/other/flag-earth.svg';
import DateRangePickerWrapper from '../../../../../components/DatePicker/DateRangePickerWrapper';
import Loader from '../../../../../components/Loader';
import {getIncrease} from '../../../../../helpers/stats';
import './index.css';

// Maybe some day use a translation package on this project ?
const translations = {
  android: 'Android',
  ios: 'iOS',
  web: 'Web',
  'android,web': 'Android & Web',
  'ios,web': 'iOS & Web',
  'android,ios': 'Android & iOS',
  'android,ios,web': 'Android, iOS & Web',
};

let chart;

class PlatformsWidget extends React.Component {
  constructor(props) {
    super(props);

    // We set the date to yesterday and we subtract 30 days
    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
    const start = moment(today.setDate(today.getDate() - 30)).format(
      'YYYY-MM-DD',
    );

    this.state = {end, start, lang: 'ALL'};
  }

  fetchStats() {
    const {end, start} = this.state;
    const {isFetching} = this.props;
    if (!isFetching) {
      this.props.dispatch(
        fetchStatsPlatforms(
          {
            endDate: moment(end).format('YYYY-MM-DD'),
            startDate: moment(start).format('YYYY-MM-DD'),
          },
          null,
          (type, error) =>
            swal({
              title: `Oops...`,
              type: 'error',
              html:
                `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
                `<pre><code>${JSON.stringify(
                  error,
                  undefined,
                  4,
                )}</code></pre>`,
            }),
        ),
      );
    }
  }

  toggleLang(value) {
    const {lang} = this.state;

    if (lang === value) {
      this.setState({lang: 'ALL'});
    } else {
      this.setState({lang: value});
    }
  }

  componentDidMount() {
    const ctx = document.getElementById('users-connections-platforms');
    if (ctx)
      chart = new Chart(ctx, {
        type: 'bar',
        data: {datasets: []},
        options: {
          scales: {
            xAxes: [
              {
                id: 'date',
                type: 'time',
                stacked: true,
              },
            ],
            yAxes: [
              {
                id: 'members',
                type: 'linear',
                stacked: true,
              },
            ],
          },
        },
      });
  }

  updateGraph(data) {
    const {usersConnections} = data;
    const {lang} = this.state;

    const datasets = [
      {
        label: 'Android',
        backgroundColor: '#ed9728',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'iOS',
        backgroundColor: '#9fc99e',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Android & iOS',
        backgroundColor: '#4a54e7',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Postman',
        backgroundColor: '#819bb7',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
    ];

    map(usersConnections, stat => {
      if (stat['android']) {
        datasets[0].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat['android'][lang], 10),
        });
      }
      if (stat['ios']) {
        datasets[1].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat['ios'][lang], 10),
        });
      }
      if (stat['android,ios']) {
        datasets[2].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat['android,ios'][lang], 10),
        });
      }
      if (stat['postman, postman']) {
        datasets[3].data.push({
          x: moment(stat.date).format('LL'),
          y: parseInt(stat['postman, postman'][lang], 10),
        });
      }
    });

    if (chart) {
      chart.data.datasets = datasets;
      chart.update();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data) {
      this.updateGraph(nextProps.data);
    }
  }

  componentDidUpdate() {
    this.props.data && this.updateGraph(this.props.data);
  }

  static renderRow(
    name,
    current,
    previous = 0,
    totalCurrent,
    totalPrevious,
    id,
  ) {
    const currentPercent = (current / totalCurrent) * 100;
    const infinity = previous === 0 && current !== 0;
    const increase = getIncrease(current, previous) || 0;

    return (
      <tr key={`${id}-${name}`}>
        <td style={{width: '150px '}}>{translations[name] || name}</td>
        <th>{numeral(current).format('0,0')}</th>
        <td style={{width: '150px '}} className="text-center">
          {numeral(currentPercent).format('0')} %
        </td>
        <td style={{width: '150px '}} className="text-center">
          {numeral(previous).format('0,0')}
        </td>
        <td
          style={{width: '150px '}}
          className={classNames('text-center', {
            'text-green': current > previous,
            'text-red': previous > current,
          })}>
          {infinity ? (
            <span>
              +<span style={{fontSize: '18px'}}>∞</span>
            </span>
          ) : (
            numeral(increase).format('+0')
          )}{' '}
          %
        </td>
      </tr>
    );
  }

  renderTable() {
    const id = 'platforms-stats-table';
    const {data, isFetching} = this.props;
    const {lang} = this.state;

    if (!isFetching && data) {
      const sumCurrent = sum(
        map(data.countries[lang].current, platform => platform.count),
      );
      const sumPrevious = sum(
        map(data.countries[lang].previous, platform => platform.count),
      );

      const infinity = sumPrevious === 0 && sumCurrent !== 0;
      const increase = getIncrease(sumCurrent, sumPrevious) || 0;

      const orderedTable = data.countries;
      orderedTable.current = orderBy(
        data.countries[lang].current,
        ['count', 'platforms'],
        ['desc', 'asc'],
      );

      return (
        orderedTable && (
          <div id={id} className="mb-4">
            <div className="mt-3 table-responsive">
              <table className="table table-bordered no-margin table-striped">
                <thead>
                  <tr className="bg-gray">
                    <th>Plateformes</th>
                    <th>Nombre d'utilisateurs</th>
                    <th className="text-center">%</th>
                    <th className="text-center">vs S-1</th>
                    <th className="text-center">% S-1</th>
                  </tr>
                </thead>
                <tbody>
                  {map(orderedTable.current, (current, i) => {
                    const previous = find(orderedTable.previous, {
                      platforms: current.platforms,
                    });
                    return PlatformsWidget.renderRow(
                      current.platforms,
                      current.count,
                      previous && previous.count,
                      sumCurrent,
                      sumPrevious,
                      id,
                    );
                  })}
                  <tr>
                    <td style={{width: '150px '}}>Total</td>
                    <th>{numeral(sumCurrent).format('0,0')}</th>
                    <td style={{width: '150px '}} className="text-center">
                      100 %
                    </td>
                    <td style={{width: '150px '}} className="text-center">
                      {numeral(sumPrevious).format('0,0')}
                    </td>
                    <td
                      style={{width: '150px '}}
                      className={classNames('text-center', {
                        'text-green': sumCurrent > sumPrevious,
                        'text-red': sumPrevious > sumCurrent,
                      })}>
                      {infinity ? (
                        <span>
                          +<span style={{fontSize: '18px'}}>∞</span>
                        </span>
                      ) : (
                        numeral(increase).format('+0')
                      )}{' '}
                      %
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )
      );
    }
  }

  render() {
    const {end, start, lang} = this.state;
    const {isFetching} = this.props;

    return (
      <div id="platforms-stats-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-desktop" /> Plateformes / Devices
            </h3>
            <br />
            Nombre de users s'étant connectés sur la plateforme
          </div>
          <div className="box-body">
            <div className="text-center">
              <div className="inline lang">
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'FR',
                  })}
                  onClick={() => this.toggleLang('FR')}>
                  <span className="flag-icon flag-icon-fr" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'GB',
                  })}
                  onClick={() => this.toggleLang('GB')}>
                  <span className="flag-icon flag-icon-gb" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'ES',
                  })}
                  onClick={() => this.toggleLang('ES')}>
                  <span className="flag-icon flag-icon-es" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'OTHER',
                  })}
                  onClick={() => this.toggleLang('OTHER')}>
                  <img
                    src={earthFlag}
                    alt="Drapeau de la terre"
                    className="flag-img-btn"
                  />
                </button>
              </div>
              <div className="inline data-range-picker">
                <DateRangePickerWrapper
                  initialStartDate={moment(start)}
                  initialEndDate={moment(end)}
                  minimumNights={0}
                  onDatesChange={({startDate, endDate}) => {
                    this.setState({
                      start: moment(startDate).format('YYYY-MM-DD'),
                      end: moment(endDate).format('YYYY-MM-DD'),
                    });
                  }}
                />
                <button
                  className="btn btn-default"
                  onClick={() => this.fetchStats()}>
                  <i className="fa fa-refresh" />
                </button>
              </div>
            </div>
          </div>
          {isFetching && <Loader />}
          <div className="row">
            <div className="col-xs-12">
              <div
                className={classNames(
                  'chart',
                  this.props.data ? 'displayGraphs' : 'notDisplayGraphs',
                )}>
                <canvas id="users-connections-platforms" />
              </div>
            </div>
            <div className="col-xs-12">{this.renderTable()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => state.app.statistics.platforms,
  dispatch => ({dispatch}),
)(PlatformsWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/Platforms/index.js